import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        position: 'absolute',
        backgroundColor: props.colors.transparentPrimary,
        justifyContent: 'center',
        alignItems: 'center',
      },
      popupContainer: {
        backgroundColor: props.colors.white,
        paddingHorizontal: 16,
        paddingVertical: 20,
        borderRadius: 14,
        width: '100%',
      },
      popupTopView: {
        alignItems: 'center',
        flexDirection: 'row',
        marginBottom: 8,
      },
      statusImage: {
        width: 24,
        height: 24,
      },
      statusText: {
        ...props.typography.interSemiBold,
        fontSize: 18,
        marginHorizontal: 6,
        flex: 1,
        color: props.colors.black,
      },
      text: {
        ...props.typography.interRegular,
        fontSize: 16,
        color: props.colors.black,
      },
      crossImage: {
        width: 16,
        height: 16,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        container: {
          backgroundColor: props.colors.transparent,
          right: 20,
          top: 64,
          width: 350,
        },
        popupContainer: {
          flex: 1,
          ...(Platform.OS == 'web'
            ? {boxShadow: `0px 0px 10px ${props.colors.shadowGrey}`}
            : {}),
        },
      },
      [maxSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE)]: {
        container: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          paddingHorizontal: 50,
        },
      },
    },
  )();
